import { Component } from 'react';

class ExtraButtons extends Component {
    constructor() {
        super();
    }

    render() {
        const { t } = this.props;
        return (
            <>
                <div className="table-header-subtitle">
                    {t('search.evergreen.extra_buttons', {
                        currentValue: this.props.currentValue,
                    })}
                </div>
            </>
        );
    }
}

export default ExtraButtons;
